import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authSimpleCanActivate } from "@delon/auth";
import { LayoutDefaultComponent } from "src/app/layout/default/default.component";
import { NotificationsComponent } from "./notifications.component";

const routes: Routes = [
    {
		path: "",
		component: LayoutDefaultComponent,
		canActivate: [authSimpleCanActivate],
		data: {title: "notifications", titleI18n: "PAGE_TITLES.NOTIFICATIONS"},
		children: [
            {
                path:"",
                component: NotificationsComponent,
                data: {title: "Notifcations", titleI18n: "PAGE_TITLES.NOTIFICATIONS"},
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports:[RouterModule]
})

export class NotificationsRoutingModule {}